// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TeamCardTabItem[data-v-6035d662]{margin-top:8px;max-height:250px;min-height:250px;overflow:auto}.TeamCardTab[data-v-6035d662]{font-size:.8em}.ListText[data-v-6035d662]{color:initial}.i-size[data-v-6035d662]{min-height:390px;max-height:390px}", ""]);
// Exports
module.exports = exports;
